/**
 * Enumeration of lunar phases as emoji for the Northern Hemisphere.
 */
export enum NorthernHemisphereLunarEmoji {
  NEW = "🌑",
  WAXING_CRESCENT = "🌒",
  FIRST_QUARTER = "🌓",
  WAXING_GIBBOUS = "🌔",
  FULL = "🌕",
  WANING_GIBBOUS = "🌖",
  LAST_QUARTER = "🌗",
  WANING_CRESCENT = "🌘",
}

/**
 * Enumeration of lunar phases as emoji for the Southern Hemisphere.
 */
export enum SouthernHemisphereLunarEmoji {
  NEW = "🌑",
  WAXING_CRESCENT = "🌘",
  FIRST_QUARTER = "🌗",
  WAXING_GIBBOUS = "🌖",
  FULL = "🌕",
  WANING_GIBBOUS = "🌔",
  LAST_QUARTER = "🌓",
  WANING_CRESCENT = "🌒",
}
